import { render, staticRenderFns } from "./tarifasForm.vue?vue&type=template&id=38937d34&scoped=true"
import script from "./tarifasForm.vue?vue&type=script&lang=js"
export * from "./tarifasForm.vue?vue&type=script&lang=js"
import style0 from "./tarifasForm.vue?vue&type=style&index=0&id=38937d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38937d34",
  null
  
)

export default component.exports